export default __webpack_public_path__ + "static/m-mark-49bf4bfb289f98c94a5235cb9a87f985.png";